import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import SearchBox from '../search-box/search-box.component';

export interface ProspectsPageBarProps {
  title: string;
  createButton: ReactNode;
  onSearch: (query: string) => void;
  onSearchClear: () => void;
  searchPlaceholder?: string;
  children?: ReactNode;
}

export default function ProspectsPageBar({
  title,
  createButton,
  onSearch,
  onSearchClear,
  searchPlaceholder = 'Dealership name starts with',
  children,
}: ProspectsPageBarProps) {
  return (
    <>
      <div>
        <h2 className="pb-2 mt-4 mb-3 border-bottom">{title}</h2>
      </div>
      <div>
        <div className="pb-2 mt-4 mb-3">
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
            {createButton}
            <SearchBox
              placeholder={searchPlaceholder}
              handleSubmit={onSearch}
              handleClearAll={onSearchClear}
            />
            {children}
          </Box>
        </div>
      </div>
    </>
  );
}
